import React from 'react';

const SessionExpired = () => (
  <div className="error-message">
    <h1 className="error-info">Your session has expired</h1>
    <h3 className="error-more">Please log in and try again.</h3>
</div>
);

export default (SessionExpired);